import CryptoJS from 'crypto-js';
import { toast } from 'react-toastify';
import History from '../../@history';


export const encryptData = (value) => {
    const data = CryptoJS.AES.encrypt(
        JSON.stringify(value),
        process.env.REACT_APP_ENC_SECRET
    ).toString();
    return data;
}

export const decryptData = (value) => {
    try {
        if (value) {
            const bytes = CryptoJS.AES.decrypt(value, process.env.REACT_APP_ENC_SECRET);
            const data = bytes.toString(CryptoJS.enc.Utf8)
            if (JSON.parse(data)) {
                return JSON.parse(data);
            }
            else {
                toast("Session expired.", {
                    autoClose: true,
                    type: "error"
                })
                localStorage.removeItem('userData');
                History.push('/login')
            }
        }
    }
    catch (e) {
        localStorage.removeItem('userData');
        History.push('/login')
    }
};

export const decryptOTp = (value, secretKey) => {
    try {
        if (value) {
            const bytes = CryptoJS.AES.decrypt(value, secretKey)
            const data = bytes.toString(CryptoJS.enc.Utf8)
            if (data) {
                return JSON.parse(data)
            }
            else {
                return ""
            }
        }
    } catch (error) {
        return ""
    }
}